import {
  completeInformation,
  updateProfile,
} from "../../../services/rest/users/userService";
import { validateForm } from "./validateUser";

export const handleSubmit = async ({ setErrors, userData, status, _id }) => {
  try {
    const validatorErrors = validateForm(userData);
    if (Object.keys(validatorErrors).length !== 0) {
      // console.log(validatorErrors);

      setErrors(validatorErrors);
      return { response: undefined };
    }
    delete userData.rol;
    delete userData.emailVerified;
    delete userData.phoneVerified;
    delete userData.age;
    delete userData.email;
    const newData = { ...userData };
    const [año, mes, dia] = userData?.dateBirth.split("-");
    const fechaFormateada = `${dia}/${mes}/${año}`;
    newData["dateBirth"] = fechaFormateada;
    // console.log("DAtos a enviar", newData);
    if (status === "active") {
      // console.log("Status activo");
      const response = await updateProfile({ userData: newData, _id });
      return { response };
    }
    // console.log("Status pendiente");
    const response = await completeInformation(newData);
    return response;
  } catch (error) {
    setErrors({});
    // console.log("respuesta handle", error);
    throw error;
  }
};
